import { render } from "./AppSidebar.vue?vue&type=template&id=c7a6fb3c"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jissjohnson/code/Bitwissend/gnaw-now-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__